import React from "react";

const ButtonTransParent = (props) => <button {...props} type="button" className={"btn btn-transparent"}></button>;

export default ButtonTransParent;
